import { faEquals } from "@fortawesome/pro-regular-svg-icons";
import { Box } from "@mui/material";

import { Icon } from "@/components/ui-v2";

export const BestMatchPresetIcon = () => (
  <Box
    sx={[
      {
        height: 24,
        width: 24,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      (theme) => ({
        backgroundColor: theme.palette.secondary[6],
        boxShadow: `inset 0 0 0 0.5px ${theme.palette.secondary["4/50"]}`,
      }),
    ]}
  >
    <Box
      sx={{
        minWidth: 24,
        minHeight: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Icon icon={faEquals} size="small" />
    </Box>
  </Box>
);
